module.exports = __webpack_public_path__ + "static/media/profile3.2a6a979d.jpg";